<template>
    <div component="HomeMenu" direction="horizontal" type="" color="light">
        <nav>
            <nav-button class="item" :link="'/voice-database'" :text="'VOICE & FACE DATABASE'" :icon="'mic_none'" />
            <nav-button class="item" :link="'/music-zone'" :text="'MUSIC ZONE'" :icon="'queue_music'" />
            <nav-button class="item" :link="'/about'" :text="'ABOUT'" :icon="'portrait'" />
        </nav>
        <nav-button class="close" :link="'/'" size="icon" color="ghost" :icon="'close'" />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
//import Velocity from 'velocity-animate';

export default {
    name: 'HomeMenu',
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='HomeMenu'] {
    margin-bottom: 30px;
    display: flex;

    @media (min-width: 980px) {
        margin-top: 25px;
    }

    .close {
        margin-left: 10px;
    }

    nav {
        display: flex;

        [component='NavButton'] {
            .gradientDark;
            &:before {
                .gradientLighten;
            }

            &.router-link-exact-active,
            &.router-link-active {
                .gradientDarkenMore;
                &:before {
                    .gradientDarken;
                }

                // background-color: @white;
            }
        }
    }
}

[component='HomeMenu'][direction='horizontal'] {
    nav {
        flex-direction: flex;

        [component='NavButton'] {
            border-radius: 0px;
            margin-right: 3px;

            &:before {
                border-radius: 0px;
            }

            &:first-child {
                .radiusXxl-l;
                &:before {
                    .radiusXxl-l;
                }
            }

            &:last-child {
                margin-right: 0px;
                .radiusXxl-r;
                &:before {
                    .radiusXxl-r;
                }
            }
        }
    }
}

[component='HomeMenu'][direction='vertical'] {
    nav {
        flex-direction: column;

        [component='NavButton'] {
            border-radius: 0px;
            margin-bottom: 3px;
            padding: 0 10px;

            &:first-child {
                border-radius: 15px 15px 0 0;
                &:before {
                    border-radius: 15px 15px 0 0;
                }
            }

            &:last-child {
                margin-bottom: 0px;
                border-radius: 0 0 15px 15px;
                &:before {
                    border-radius: 0 0 15px 15px;
                }
            }
        }
    }
}

[component='HomeMenu'][color='light'] {
    nav {
        [component='NavButton'] {
            .icon {
                border: 4px solid red;
            }

            span,
            .text,
            .icon,
            i {
                color: black !important;
                stroke: black !important;
                fill: black !important;
            }

            .gradientLight;

            &:before {
                .gradientDarken;
            }

            &.router-link-exact-active,
            &.router-link-active {
                .gradientDark;
                &:before {
                    .gradientDarken;
                }

                // background-color: @white;
            }
        }
    }
}
</style>
